import Person from '../../models/Person'
import requestAction from '../../utils/requestAction'

export const fetchPerson = (personId: string, handleResponse?: (person: Person) => void) =>
  requestAction('PERSON_DETAIL')(`people/${personId}`, 'GET',
    undefined,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.person) })
